import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { identity, pickBy } from 'lodash';

import { API_URL } from '../../../common/constants/api-url';
import { getBaseQuery } from '../base-query';
import { GetDomainsParams, GetDomainsResBody } from './domains-api-types';

export const domainsApiSlice = createApi({
  baseQuery: getBaseQuery({
    baseUrl: `${API_URL}/admin/domains`
  }),
  endpoints: (builder) => ({
    getDomains: builder.query<GetDomainsResBody, GetDomainsParams>({
      query: (params) => ({
        method: 'GET',
        params: { limit: 20, offset: 0, ...pickBy(params, identity()) },
        url: '',
      }),
      transformResponse: (data: GetDomainsResBody) => ({
        domains: data.domains.filter((d) => ![4, 5, 6].includes(d.id)),
        totalCount: data.totalCount,
      })
    })
  }),
  reducerPath: 'domains'
});
